var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/CommonGallery/CommonGallery.jinja"] = require( "front/components/CommonGallery/CommonGallery.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/CommonStory/CommonStoryMembers.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/CommonStory/CommonStoryMembers.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/CommonGallery/CommonGallery.jinja", false, "assets/app/front/components/CommonStory/CommonStoryMembers.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "CommonGallery")) {
var t_7 = t_4.CommonGallery;
} else {
cb(new Error("cannot import 'CommonGallery'")); return;
}
context.setVariable("CommonGallery", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"CommonStoryBlock CommonStoryMembers\">\n\n        <h3>Featured Members</h3>\n\n        <div class=\"CommonStoryMembers-wrapperDesktop\">\n            ";
frame = frame.push();
var t_12 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"members");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("item", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_9 += "\n                <a href=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((t_13),"memberUrl"), env.opts.autoescape);
t_9 += "\">\n                <figure class=\"CommonStoryMembers-member\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"";
t_9 += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") % 4) * 50, env.opts.autoescape);
t_9 += "\">\n                    <div class=\"CommonStoryMembers-memberImage\">\n                        <img src=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_13),"img")),"w680_url"), env.opts.autoescape);
t_9 += "\"\n                          srcset=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_13),"img")),"w1680_url"), env.opts.autoescape);
t_9 += " 1366w,\n                                  ";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_13),"img")),"w680_url"), env.opts.autoescape);
t_9 += " 680w\"\n                          sizes=\"(max-width: 759px) 1, ";
t_9 += "\n                                 100vw\"\n                          alt=\"\">\n                    </div>\n                    <figcaption class=\"CommonStoryMembers-memberCaption\">";
t_9 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_13),"caption")), env.opts.autoescape);
t_9 += "</figcaption>\n                </figure>\n                </a>\n            ";
;
}
}
frame = frame.pop();
t_9 += "\n        </div>\n\n        <div class=\"CommonStoryMembers-wrapperMobile\">\n            ";
t_9 += runtime.suppressValue((lineno = 28, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonGallery"), "CommonGallery", context, [runtime.makeKeywordArgs({"data": {"title": "Featured Members","aspect": 1000 / 560,"captionStyle": "FeaturedMembers","hasTitle": runtime.contextOrFrameLookup(context, frame, "False"),"images": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content")),"members")}})])), env.opts.autoescape);
t_9 += "\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("CommonStoryMembers");
context.setVariable("CommonStoryMembers", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/CommonStory/CommonStoryMembers.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonStory/CommonStoryMembers.jinja
// module id = 93
// module chunks = 0